import React, { useEffect, useState } from "react";
import { SectionTitle, Loading } from "../components/common";
import { LeagueTable } from "../components/LeagueTable";
import { TopScorers } from "../components/TopScorers";
import client from "../lib/api";

export default function TablePage() {
  const [rows, setRows] = useState(null);
  useEffect(() => { client.get("/table").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  if (!rows) return <Loading />;
  return (
    <div data-testid="table-page">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-4">
        <SectionTitle kicker="Official standings">Castle Lager PSL Table</SectionTitle>
      </div>
      <LeagueTable rows={rows} />
      <p className="text-xs text-ink/40 mt-3">Standings after the latest completed matchday · maintained by the PSL desk.</p>

      <div className="mt-12">
        <TopScorers />
        <p className="text-xs text-ink/40 mt-3">Golden Boot race after Matchday 28.</p>
      </div>
    </div>
  );
}
